/**
 * Global error notifier - App.tsx registers the snackbar ref.
 * Used by handleException to show default error toasts when notifyUser is true.
 */
import type { RefObject } from 'react';

type Notifier = {
  enqueueSnackbar: (opts: { message: string; variant: string }) => void;
};

let notifierRef: RefObject<Notifier> | null = null;

export function setErrorNotifierRef(ref: RefObject<Notifier> | null) {
  notifierRef = ref;
}

export function notifyError(message = 'An error occurred') {
  notifierRef?.current?.enqueueSnackbar?.({ message, variant: 'error' });
}
